
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Time = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <g>
            <polygon points="13.31 6.21 11.69 6.21 11.69 12.93 16.11 15.6 16.94 14.22 13.31 12.02 13.31 6.21"></polygon>
            <path d="M12.5,1.9A10.7,10.7,0,0,0,1.9,12.5,10.7,10.7,0,0,0,12.5,23.1,10.7,10.7,0,0,0,23.1,12.5,10.7,10.7,0,0,0,12.5,1.9Zm0,19.7a9.1,9.1,0,1,1,9.1-9.1,9.09,9.09,0,0,1-9.1,9.1Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Time.defaultProps = {
  title: 'Time',
};

export default Time;
